import { Tooltip } from '@lokalise/louis';
import React, { useState } from 'react';
import { components } from 'react-select';
import type { GroupBase, MultiValueGenericProps } from 'react-select';

import isEllipsisActive from '@app/utils/isEllipsisActive';

import { Item } from '../styles';

const MultiValueLabel = <Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(
    props: MultiValueGenericProps<Option, IsMulti, Group>,
) => {
    const {
        data,
        selectProps: { getOptionLabel },
    } = props;

    const [itemEl, setItemEl] = useState<HTMLElement | null>(null);

    const ellipsisView = isEllipsisActive(itemEl);

    const label = getOptionLabel(data);

    return (
        <Tooltip tooltip={label} show={ellipsisView}>
            <div>
                <components.MultiValueLabel {...props}>
                    <Item ref={setItemEl}>{label}</Item>
                </components.MultiValueLabel>
            </div>
        </Tooltip>
    );
};

export default MultiValueLabel;
